import { makeStyles } from "@mui/styles";
import { BaseThemeOptions } from "themes/base";

export const useStyles = makeStyles((theme: BaseThemeOptions) => ({
	sectionContainer: {
		display: "flex",
		flexDirection: "column",
		alignItems: "start",
		width: "100%",
		padding: "8px 24px",
	},
	sectionLabel: {
		display: "flex",
		justifyContent: "center",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		overflow: "hidden",
	},
	sectionLabelText: {
		color: theme.palette.gray2.main,
		fontSize: "0.85rem",
		fontWeight: "400",
	},
}));
